import React from 'react';

// One custom survey question with 1..N score buttons. Shown below the timing
// buttons during a test (never blocks them) and on the end-of-test screen.
const styles = {
  card: {
    backgroundColor: '#16213e',
    border: '2px solid #ffcc00',
    borderRadius: '16px',
    padding: '16px',
    marginTop: '12px',
    marginBottom: '12px',
  },
  label: {
    color: '#ffcc00',
    fontSize: '12px',
    fontWeight: 'bold',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    marginBottom: '6px',
  },
  question: {
    color: '#ffffff',
    fontSize: '34px',
    fontWeight: 'bold',
    lineHeight: 1.15,
    marginBottom: '14px',
  },
  grid: {
    display: 'grid',
    gap: '8px',
  },
  scoreButton: {
    height: '52px',
    backgroundColor: '#0f3460',
    border: '2px solid #0f3460',
    borderRadius: '10px',
    color: '#ffffff',
    fontSize: '20px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  scoreButtonSelected: {
    height: '52px',
    backgroundColor: '#ffcc00',
    border: '2px solid #ffcc00',
    borderRadius: '10px',
    color: '#1a1a2e',
    fontSize: '20px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  hint: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#a0a0b0',
    fontSize: '12px',
    marginTop: '6px',
  },
  skip: {
    marginTop: '10px',
    background: 'none',
    border: 'none',
    color: '#a0a0b0',
    fontSize: '14px',
    textDecoration: 'underline',
    cursor: 'pointer',
    padding: 0,
  },
};

export default function SurveyCard({ question, selected, onScore, onSkip }) {
  const n = question.scale_max;
  const scores = Array.from({ length: n }, (_, i) => i + 1);
  const cols = n <= 5 ? n : Math.ceil(n / 2);
  return (
    <div style={styles.card}>
      <div style={styles.label}>Survey {question.slot} · Score 1 to {n}</div>
      <div style={styles.question}>{question.question_text}</div>
      <div style={{ ...styles.grid, gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
        {scores.map(s => (
          <button
            key={s}
            style={selected === s ? styles.scoreButtonSelected : styles.scoreButton}
            onClick={() => onScore(s)}
          >
            {s}
          </button>
        ))}
      </div>
      <div style={styles.hint}>
        <span>1 = lowest</span>
        <span>{n} = highest</span>
      </div>
      {onSkip && (
        <button style={styles.skip} onClick={onSkip}>Skip for now (ask at end of test)</button>
      )}
    </div>
  );
}
